import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { Panel } from '@idealmediaworks/lookingglass-ui-framework';
import RegionArea from '../containers/regionArea/RegionArea';

const PanelRegions: React.FC = (): JSX.Element => {
  return (
    <Panel>
      <RegionArea />
    </Panel>
  );
};

export default PanelRegions;
